module.exports = __webpack_public_path__ + "img/17.739a5f41.svg";